import { enableDisableToolbarItems, enableToolbarItem, updateSelectAllCheckbox } from './organize-toolbar';
import { rearrangePages } from './organizepages-editor';
import { disableTileCopyButton, disableTileCopyRotateButton, disableTileDeleteButton, updateTempRotationDetail } from './tile-interaction';
import { updatePageDetail } from './organize-initialization';
import { deleteTempPage, insertRemovedPages, undoDeletedPage } from './organize-undoredoutils';
import { inputTextboxUpdate } from './organize-extract';
/**
 * @param {OrganizeDetails[]} UndoRedoTileActions - Specifies the details of the action occured page
 * @param {string} actionString - Specifies the Name of the action
 * @param {OrganizeDetails[]} toolbarActions - Collection to store multiple action as single action
 * @param {number[]} selectedPageIndexes - Collection to store selected page index
 * @param {number} dropIndex - Specifies where the page should be dropped
 * @param {boolean} isRightInsertion - Used to check whether the page should be dropped at right
 * @returns {void}
 * @private
 */
export function addOrganizeAction(UndoRedoTileActions, actionString, toolbarActions, selectedPageIndexes, dropIndex, isRightInsertion) {
    var action = {
        UndoRedoTileActions: UndoRedoTileActions, action: actionString, toolbarActions: toolbarActions,
        selectedPagesIndexes: selectedPageIndexes, dropIndex: dropIndex,
        isRightInsertion: isRightInsertion
    };
    this.undoOrganizeCollection.push(action);
    this.redoOrganizeCollection = [];
    updateUndoRedoButtons.call(this);
}
/**
 * @private
 * @returns { void }
 */
export function updateUndoRedoButtons() {
    var _this = this;
    this.toolbar.items.forEach(function (item) {
        if (item.id === _this.pdfViewer.element.id + '_undo_organize_Pages') {
            enableToolbarItem.call(_this, item.id, (_this.undoOrganizeCollection.length > 0));
        }
        else if (item.id === _this.pdfViewer.element.id + '_redo_organize_Pages') {
            enableToolbarItem.call(_this, item.id, (_this.redoOrganizeCollection.length > 0));
        }
    });
}
/**
 * @private
 * @returns { void }
 */
export function restorePagesBeforeZoom() {
    var undoCollectionLength = this.undoOrganizeCollection.length;
    if (undoCollectionLength > 0) {
        /* eslint-disable security/detect-object-injection */
        for (var index = undoCollectionLength - 1; index >= 0; index--) {
            var undoActionObject = this.undoOrganizeCollection[index];
            undoActionHandler.call(this, undoActionObject);
        }
        /* eslint-enable security/detect-object-injection */
    }
}
/**
 * @private
 * @returns { void }
 */
export function restorePagesAfterZoom() {
    var undoCollectionLength = this.undoOrganizeCollection.length;
    if (undoCollectionLength > 0) {
        /* eslint-disable security/detect-object-injection */
        for (var index = 0; index < undoCollectionLength; index++) {
            var redoActionObject = this.undoOrganizeCollection[index];
            redoActionHandler.call(this, redoActionObject);
        }
        /* eslint-enable security/detect-object-injection */
    }
}
/**
 * @private
 * @param {IActionOrganizeElements} undoActionObject - It's describe about undo action object.
 * @returns { void }
 */
export function undoActionHandler(undoActionObject) {
    if (undoActionObject) {
        var actionObject_1 = JSON.parse(JSON.stringify(undoActionObject));
        switch (actionObject_1.action) {
            case 'Insert Right':
            case 'Insert Left':
            case 'Import Pages':
            case 'Copy':
                removePage.call(this, actionObject_1.UndoRedoTileActions[0].currentPageIndex);
                break;
            case 'Rotate Right':
                rotateImage.call(this, actionObject_1.UndoRedoTileActions[0].currentPageIndex, -90);
                break;
            case 'Rotate Left':
                rotateImage.call(this, actionObject_1.UndoRedoTileActions[0].currentPageIndex, 90);
                break;
            case 'Delete':
                {
                    var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject_1.UndoRedoTileActions[0].
                        currentPageIndex.toString(), 10)];
                    if (actionObject_1.UndoRedoTileActions[0].isCopied) {
                        insertRemovedPages.call(this, actionObject_1.UndoRedoTileActions[0], actionObject_1.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                        this.tileImageRender(actionObject_1.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject_1.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false);
                    }
                    else if (actionObject_1.UndoRedoTileActions[0].isInserted) {
                        insertRemovedPages.call(this, actionObject_1.UndoRedoTileActions[0], actionObject_1.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                        this.tileImageRender(actionObject_1.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject_1.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, true);
                    }
                    else if (actionObject_1.UndoRedoTileActions[0].isImportedDoc) {
                        insertRemovedPages.call(this, actionObject_1.UndoRedoTileActions[0], actionObject_1.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                        this.tileImageRender(actionObject_1.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject_1.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false, true, actionObject_1.UndoRedoTileActions[0].documentName);
                    }
                    else if (!actionObject_1.UndoRedoTileActions[0].isCopied && !actionObject_1.UndoRedoTileActions[0].isInserted
                        && !actionObject_1.UndoRedoTileActions[0].isImportedDoc) {
                        undoDeletedPage.call(this, actionObject_1.UndoRedoTileActions[0].currentPageIndex, actionObject_1.UndoRedoTileActions[0].pageIndex, actionObject_1.UndoRedoTileActions[0].rotateAngle, mainTileElement);
                        this.tileImageRender(actionObject_1.UndoRedoTileActions[0].pageIndex, 0, actionObject_1.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false);
                    }
                    updatePageDetail.call(this);
                }
                break;
            case 'Move Pages':
                {
                    var dropIndex_1 = actionObject_1.dropIndex;
                    var beforeDropIndex = [];
                    var afterDropIndex = [];
                    var processedIndexes_1 = new Set();
                    // Helper function to check if index is in range
                    var isInRange_1 = function (start, end, value) { return value >= start && value <= end; };
                    var _loop_1 = function (i) {
                        var action = actionObject_1.UndoRedoTileActions[parseInt(i.toString(), 10)];
                        var selectedItem = this_1.tempOrganizePagesCollection
                            .find(function (item) {
                            if (action.isCopied) {
                                return item.copiedPageIndex === action.copiedPageIndex && isInRange_1(dropIndex_1 - actionObject_1.selectedPagesIndexes.length, dropIndex_1 + actionObject_1.selectedPagesIndexes.length, item.currentPageIndex) && !processedIndexes_1.has(item.currentPageIndex);
                            }
                            else if (action.isInserted) {
                                return item.copiedPageIndex === action.copiedPageIndex && item.isInserted && isInRange_1(dropIndex_1 - actionObject_1.selectedPagesIndexes.length, dropIndex_1 + actionObject_1.selectedPagesIndexes.length, item.currentPageIndex) && !processedIndexes_1.has(item.currentPageIndex);
                            }
                            else if (action.isImportedDoc) {
                                return item.copiedPageIndex === action.copiedPageIndex && item.isImportedDoc && isInRange_1(dropIndex_1 - actionObject_1.selectedPagesIndexes.length, dropIndex_1 + actionObject_1.selectedPagesIndexes.length, item.currentPageIndex) && !processedIndexes_1.has(item.currentPageIndex);
                            }
                            else {
                                return item.pageIndex === action.pageIndex;
                            }
                        });
                        if (selectedItem) {
                            var selectedIndexes = [selectedItem.currentPageIndex];
                            processedIndexes_1.add(selectedItem.currentPageIndex);
                            if (dropIndex_1 < action.currentPageIndex) {
                                afterDropIndex.push({ currentPageIndex: action.currentPageIndex, selectedIndexes: selectedIndexes });
                            }
                            else {
                                beforeDropIndex.push({ currentPageIndex: action.currentPageIndex, selectedIndexes: selectedIndexes });
                            }
                        }
                    };
                    var this_1 = this;
                    // Collect all selected indexes
                    for (var i = 0; i < actionObject_1.UndoRedoTileActions.length; i++) {
                        _loop_1(i);
                    }
                    // Sort and rearrange for beforeDropIndex
                    if (beforeDropIndex.length > 0) {
                        // Sort in descending order based on selectedIndexes and rearrange
                        beforeDropIndex.sort(function (a, b) { return a.currentPageIndex - b.currentPageIndex; });
                        for (var j = 0; j < beforeDropIndex.length; j++) {
                            // eslint-disable-next-line max-len
                            rearrangePages.call(this, beforeDropIndex[parseInt(j.toString(), 10)].selectedIndexes, beforeDropIndex[parseInt(j.toString(), 10)].currentPageIndex, beforeDropIndex[parseInt(j.toString(), 10)].currentPageIndex > beforeDropIndex[parseInt(j.toString(), 10)].selectedIndexes[0]);
                        }
                    }
                    // Sort and rearrange for afterDropIndex
                    if (afterDropIndex.length > 0) {
                        // Sort in ascending order based on currentPageIndex and rearrange
                        afterDropIndex.sort(function (a, b) { return b.currentPageIndex - a.currentPageIndex; });
                        for (var j = 0; j < afterDropIndex.length; j++) {
                            rearrangePages.call(this, afterDropIndex[parseInt(j.toString(), 10)].selectedIndexes, afterDropIndex[parseInt(j.toString(), 10)].currentPageIndex, afterDropIndex[parseInt(j.toString(), 10)].currentPageIndex >
                                afterDropIndex[parseInt(j.toString(), 10)].selectedIndexes[0]);
                        }
                    }
                    break;
                }
            case 'Toolbar Rotate Right':
                rotateImages.call(this, actionObject_1, -90);
                break;
            case 'Toolbar Rotate Left':
                rotateImages.call(this, actionObject_1, 90);
                break;
            case 'Toolbar Copy':
                if (actionObject_1.toolbarActions.length > 0) {
                    for (var i = actionObject_1.toolbarActions.length - 1; i >= 0; i--) {
                        var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject_1.toolbarActions[parseInt(i.toString(), 10)].
                            currentPageIndex.toString(), 10)];
                        deleteTempPage.call(this, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                        this.tileAreaDiv.removeChild(mainTileElement);
                        updatePageDetail.call(this);
                    }
                }
                disableTileDeleteButton.call(this);
                break;
            case 'Toolbar Delete':
                {
                    if (actionObject_1.toolbarActions.length > 0) {
                        for (var i = 0; i < actionObject_1.toolbarActions.length; i++) {
                            var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject_1.toolbarActions[parseInt(i.toString(), 10)].
                                currentPageIndex.toString(), 10)];
                            if (actionObject_1.toolbarActions[parseInt(i.toString(), 10)].isCopied) {
                                insertRemovedPages.call(this, actionObject_1.toolbarActions[parseInt(i.toString(), 10)], actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                this.tileImageRender(actionObject_1.toolbarActions[parseInt(i.toString(), 10)].copiedPageIndex, 0, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, false);
                            }
                            else if (actionObject_1.toolbarActions[parseInt(i.toString(), 10)].isInserted) {
                                insertRemovedPages.call(this, actionObject_1.toolbarActions[parseInt(i.toString(), 10)], actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                this.tileImageRender(actionObject_1.toolbarActions[parseInt(i.toString(), 10)].copiedPageIndex, 0, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, true);
                            }
                            else if (actionObject_1.toolbarActions[parseInt(i.toString(), 10)].isImportedDoc) {
                                insertRemovedPages.call(this, actionObject_1.toolbarActions[parseInt(i.toString(), 10)], actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                                this.tileImageRender(actionObject_1.toolbarActions[parseInt(i.toString(), 10)].copiedPageIndex, 0, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, false, true, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].documentName);
                            }
                            else if (!actionObject_1.toolbarActions[parseInt(i.toString(), 10)].isCopied &&
                                !actionObject_1.toolbarActions[parseInt(i.toString(), 10)].isInserted &&
                                !actionObject_1.toolbarActions[parseInt(i.toString(), 10)].isImportedDoc) {
                                undoDeletedPage.call(this, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].pageIndex, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].rotateAngle, mainTileElement);
                                this.tileImageRender(actionObject_1.toolbarActions[parseInt(i.toString(), 10)].pageIndex, 0, actionObject_1.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, false);
                            }
                            updatePageDetail.call(this);
                        }
                    }
                    disableTileDeleteButton.call(this);
                }
                break;
        }
    }
}
/**
 * @private
 * @param {IActionOrganizeElements} redoActionObject - It's describe about redo action object.
 * @returns { void }
 */
export function redoActionHandler(redoActionObject) {
    if (redoActionObject) {
        var actionObject = JSON.parse(JSON.stringify(redoActionObject));
        switch (actionObject.action) {
            case 'Insert Right':
            case 'Insert Left':
                {
                    var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.UndoRedoTileActions[0].
                        currentPageIndex.toString(), 10)];
                    insertRemovedPages.call(this, actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                    this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, true);
                    disableTileCopyButton.call(this);
                    updatePageDetail.call(this);
                }
                break;
            case 'Rotate Right':
                rotateImage.call(this, actionObject.UndoRedoTileActions[0].currentPageIndex, 90);
                break;
            case 'Rotate Left':
                rotateImage.call(this, actionObject.UndoRedoTileActions[0].currentPageIndex, -90);
                break;
            case 'Copy':
                {
                    var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.UndoRedoTileActions[0].
                        currentPageIndex.toString(), 10)];
                    insertRemovedPages.call(this, actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                    this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false);
                    updatePageDetail.call(this);
                }
                break;
            case 'Import Pages':
                {
                    var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.UndoRedoTileActions[0].
                        currentPageIndex.toString(), 10)];
                    insertRemovedPages.call(this, actionObject.UndoRedoTileActions[0], actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement);
                    this.tileImageRender(actionObject.UndoRedoTileActions[0].copiedPageIndex, 0, actionObject.UndoRedoTileActions[0].currentPageIndex, mainTileElement, true, true, false, true, actionObject.UndoRedoTileActions[0].documentName);
                    disableTileCopyRotateButton.call(this);
                    updatePageDetail.call(this);
                }
                break;
            case 'Delete':
                removePage.call(this, actionObject.UndoRedoTileActions[0].currentPageIndex);
                break;
            case 'Move Pages':
                rearrangePages.call(this, actionObject.selectedPagesIndexes, actionObject.dropIndex, actionObject.isRightInsertion);
                break;
            case 'Toolbar Rotate Right':
                rotateImages.call(this, actionObject, 90);
                break;
            case 'Toolbar Rotate Left':
                rotateImages.call(this, actionObject, -90);
                break;
            case 'Toolbar Copy':
                {
                    if (actionObject.toolbarActions.length > 0) {
                        for (var i = 0; i < actionObject.toolbarActions.length; i++) {
                            var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.toolbarActions[parseInt(i.toString(), 10)].
                                currentPageIndex.toString(), 10)];
                            insertRemovedPages.call(this, actionObject.toolbarActions[parseInt(i.toString(), 10)], actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                            this.tileImageRender(actionObject.toolbarActions[parseInt(i.toString(), 10)].copiedPageIndex, 0, actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement, true, true, false);
                            updatePageDetail.call(this);
                        }
                    }
                    disableTileDeleteButton.call(this);
                }
                break;
            case 'Toolbar Delete':
                if (actionObject.toolbarActions.length > 0) {
                    for (var i = actionObject.toolbarActions.length - 1; i >= 0; i--) {
                        var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.toolbarActions[parseInt(i.toString(), 10)].
                            currentPageIndex.toString(), 10)];
                        deleteTempPage.call(this, actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, mainTileElement);
                        this.tileAreaDiv.removeChild(mainTileElement);
                        updatePageDetail.call(this);
                    }
                }
                disableTileDeleteButton.call(this);
                break;
        }
    }
}
/**
 * @private
 * @returns { void }
 */
export function undo() {
    var undoActionObject = this.undoOrganizeCollection.pop();
    undoActionHandler.call(this, undoActionObject);
    if (this.isExtractToolbarVisible) {
        inputTextboxUpdate.call(this);
    }
    this.redoOrganizeCollection.push(undoActionObject);
    updateSelectAllCheckbox.call(this);
    enableDisableToolbarItems.call(this);
    updateUndoRedoButtons.call(this);
}
/**
 * @private
 * @returns { void }
 */
export function redo() {
    var redoActionObject = this.redoOrganizeCollection.pop();
    redoActionHandler.call(this, redoActionObject);
    if (this.isExtractToolbarVisible) {
        inputTextboxUpdate.call(this);
    }
    this.undoOrganizeCollection.push(redoActionObject);
    updateSelectAllCheckbox.call(this);
    enableDisableToolbarItems.call(this);
    updateUndoRedoButtons.call(this);
}
/**
 * @private
 * @param {number} pageOrder - It's describe about page order.
 * @returns { void }
 */
export function removePage(pageOrder) {
    var mainTileElement = this.tileAreaDiv.childNodes[parseInt(pageOrder.toString(), 10)];
    deleteTempPage.call(this, pageOrder, mainTileElement);
    this.tileAreaDiv.removeChild(mainTileElement);
    updatePageDetail.call(this);
}
/**
 * @private
 * @param {IActionOrganizeElements} actionObject - It's describe about action object.
 * @param {number} rotationAngle - It's describe about page rotation angle.
 * @returns { void }
 */
export function rotateImages(actionObject, rotationAngle) {
    if (actionObject.toolbarActions.length > 0) {
        for (var i = 0; i < actionObject.toolbarActions.length; i++) {
            var mainTileElement = this.tileAreaDiv.childNodes[parseInt(actionObject.toolbarActions[parseInt(i.toString(), 10)].
                currentPageIndex.toString(), 10)];
            var imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
            if (imageContainer) {
                var currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
                currentRotation = (currentRotation + rotationAngle + 360) % 360;
                imageContainer.style.transform = "rotate(" + currentRotation + "deg)";
                updateTempRotationDetail.call(this, actionObject.toolbarActions[parseInt(i.toString(), 10)].currentPageIndex, rotationAngle);
            }
        }
    }
}
/**
 * @private
 * @param {number} currentPageIndex - It's describe about current page index.
 * @param {number} rotationAngle - It's describe about page rotation angle.
 * @returns { void }
 */
export function rotateImage(currentPageIndex, rotationAngle) {
    var mainTileElement = this.tileAreaDiv.childNodes[parseInt(currentPageIndex.toString(), 10)];
    var imageContainer = mainTileElement.querySelector('.e-pv-organize-image');
    if (imageContainer) {
        var currentRotation = parseFloat(imageContainer.style.transform.replace('rotate(', '').replace('deg)', '')) || 0;
        currentRotation = (currentRotation + rotationAngle + 360) % 360;
        imageContainer.style.transform = "rotate(" + currentRotation + "deg)";
        updateTempRotationDetail.call(this, currentPageIndex, rotationAngle);
    }
}
